const problems = [
  {
    icon: "ri-phone-line",
    text: "Masz stronę, ale nikt nie dzwoni",
    color: "#ef4444",
    bg: "#fef2f2",
  },
  {
    icon: "ri-search-line",
    text: "Nie ma Cię w Google — klienci Cię nie znajdą",
    color: "#f97316",
    bg: "#fff7ed",
  },
  {
    icon: "ri-spy-line",
    text: "Konkurencja zgarnia wszystkich klientów",
    color: "#a855f7",
    bg: "#faf5ff",
  },
  {
    icon: "ri-emotion-sad-line",
    text: "Strona tylko jest, ale nie zarabia",
    color: "#6b7280",
    bg: "#f9fafb",
  },
];

const ProblemSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-[#F8FAFF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left */}
          <div>
            <span className="inline-block text-[#1D4ED8] text-sm font-semibold tracking-wide uppercase mb-4">
              Problem
            </span>
            <h2 className="text-3xl lg:text-4xl font-extrabold text-[#0F172A] leading-tight mb-6">
              Dlaczego Twoja strona<br />nie przynosi klientów?
            </h2>
            <p className="text-[#64748B] text-lg leading-relaxed mb-10">
              Większość stron nie jest robiona pod klientów, tylko pod wygląd.
              Wygląda nieźle, ale{" "}
              <strong className="text-[#0F172A]">nie zamienia odwiedzin w telefony</strong>.
            </p>

            <div className="flex flex-col gap-4">
              {problems.map((p) => (
                <div
                  key={p.text}
                  className="flex items-center gap-4 bg-white border border-gray-100 rounded-xl p-4"
                >
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ backgroundColor: p.bg }}
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${p.icon} text-lg`} style={{ color: p.color }}></i>
                    </div>
                  </div>
                  <span className="text-[#334155] font-medium text-sm lg:text-base">{p.text}</span>
                  <div className="ml-auto w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-close-circle-fill text-red-300 text-lg"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — comparison visual */}
          <div className="flex flex-col gap-5">
            <div className="bg-white rounded-2xl border border-gray-100 p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-close-line text-red-500 text-base"></i>
                  </div>
                </div>
                <p className="font-bold text-[#0F172A]">Typowa strona</p>
              </div>
              <ul className="flex flex-col gap-2.5">
                {[
                  "Zrobiona aby tylko była",
                  "Brak konkretnych CTA",
                  "Zły układ na mobile",
                  "Nie ma jej w Google",
                  "Klient wychodzi bez kontaktu",
                ].map((t) => (
                  <li key={t} className="flex items-center gap-2.5 text-sm text-[#64748B]">
                    <div className="w-4 h-4 flex items-center justify-center text-red-400 flex-shrink-0">
                      <i className="ri-close-circle-line text-base"></i>
                    </div>
                    {t}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-gradient-to-br from-[#1D4ED8] to-[#1e3a8a] rounded-2xl p-6 text-white">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-white text-base"></i>
                  </div>
                </div>
                <p className="font-bold">Strona zaprojektowana pod klientów</p>
              </div>
              <ul className="flex flex-col gap-2.5">
                {[
                  "Zbudowana pod generowanie zapytań",
                  "Widoczne CTA i numer telefonu",
                  "Perfekcyjny mobile",
                  "Lokalne SEO i Google Maps",
                  "Klient dzwoni lub wypełnia formularz",
                ].map((t) => (
                  <li key={t} className="flex items-center gap-2.5 text-sm text-white/90">
                    <div className="w-4 h-4 flex items-center justify-center text-green-300 flex-shrink-0">
                      <i className="ri-checkbox-circle-line text-base"></i>
                    </div>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
